import React from 'react';
import { Callout, CalloutProps } from './Callout';

export const Note: React.FC<Omit<CalloutProps, 'type'>> = (props) => (
  <Callout type="note" {...props} />
);

export default Note;
